import React, { useEffect } from "react";
import { getAepPayloadContentType } from "../../../externalApi/AepApi";
import { addVisibilityEventListeners, getIsWindowVisible, getLastShowReason, removeVisibilityEventListeners } from "../../../externalApi/WindowApi";
import { logPageEvent, logPageHidden, logPageShown } from "../Telemetry/PageTelemetry";
export const EmptyPage = () => {
    const handleWindowShown = async () => {
        const [aepPayloadContentType, lastShowReason] = await Promise.all([
            getAepPayloadContentType(),
            getLastShowReason()
        ]);
        logPageShown("empty-page", aepPayloadContentType, lastShowReason);
    };
    const handleWindowHidden = () => {
        logPageHidden("empty-page");
    };
    useEffect(() => {
        logPageEvent("empty-page");
        addVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        // If the Window is visible fire the visibility event since we will have missed the first on on cold launch.
        getIsWindowVisible().then((visible) => {
            if (visible) {
                handleWindowShown();
            }
        }, (reason) => {
            // If windowAPI is unavailable do nothing
        });
        return () => {
            removeVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        };
    }, []);
    return React.createElement(React.Fragment, null);
};
